
/**
 * route paths
 */

angular.module('cvsApp').service('webTrendsService', ['cvsAppData', '$cookies', function (CAD,$cookies) {
  'use strict';
 function webTrendsService (){
 	var activePresence;
    this.setActivePresence=function(data){
        activePresence=data;
    };
    this.getActivePresence=function(){
        return activePresence;
    };
     /**
      * Capturing city, state and ipAddress from global variable set in portal.
      * @param data
      * @param utagObj
      * @param from
      */
	this.webTrendsUtag=function(data,utagObj,from){
        if (from !== 'widget') {
            utagObj.environment=cvsUtility.utagUrl(true);
            utagObj.site_name="cvscaremarkspecialty.com";
            utagObj.country="US";
            utagObj.language="EN";
            utagObj.currency="USD";
            utagObj.state_logged_in=cvsUtility.queryMap.tokenId?true:false;
            utagObj.Registration_Method=this.getActivePresence()=="ACTIVE"?"Registered User":"";
            utagObj.responsivedesign = window.screen.availWidth>=960? 'dweb':window.screen.availWidth<768? 'mweb':'tweb';
            utagObj.platform = cvsUtility.getPlatform();
            utagObj.registration_state = cvsUtility.getMemberstatus();
            utagObj.page_config = "fast page";
            if(utagObj.hasOwnProperty('page_error') && utagObj.page_error){
                var hashUrl = window.location.hash.replaceAll("#/","").split('/');
                var pathName = hashUrl[0];
                var pageError = utagObj.page_error;
                // utagObj.page_error = pageError + ' ' + '|'  + ' ' + pathName;
                utagObj.page_error = pageError + '_' + ' ' + pathName;
            }
            //utagObj.state_city_ipaddress = cvsUtility.getAkamaiHeaders();
            if(cvsUtility.getPatientId()!=''){
                utagObj.patient_id = cvsUtility.getPatientId();
            }
            var patientTagCookie = $cookies.get('patientTag',  { 'path': '/'});
            if(patientTagCookie != undefined  || patientTagCookie != null || patientTagCookie != ""){
                utagObj.patientid = patientTagCookie;
            }
            var akamaiHeaders = cvsUtility.getAkamaiHeaders();
            if(akamaiHeaders && akamaiHeaders.hasOwnProperty('cvs-akclient-ip')){
                utagObj.state_city_ipaddress = akamaiHeaders['region_code'] +'|'+akamaiHeaders['city']+'|'+akamaiHeaders['cvs-akclient-ip'];
            }
            /*
                log_in_method  values are Standard SignIn, BiometricSignIn by default Standard SignIn, only for login mode
            */
            if(CAD.hasOwnProperty('isGuestRefill') && !CAD.isGuestRefill() && cvsUtility.queryMap.tokenId){
                utagObj.log_in_method = "Standard SignIn";
            }
            /**
             * SP 02/23/2017 - IM5564982
             * Added condition to verify and remove success status code from page error.
             */
            if(utagObj.hasOwnProperty('page_error') && utagObj.page_error && (utagObj.page_error.indexOf('0000') > -1 || utagObj.page_error == '')){
                delete utagObj.page_error;
            }
            else if(utagObj.hasOwnProperty('page_error')) {
                //console.log('Page -->'+utagObj.page_name+' <<-->> Page Error -->'+utagObj.page_error);
                data = "OBJ";
            }

            utagObj.sc_version = $cookies.get('prescripv2') + '|'+ $cookies.get('refillv2');
            /*utagObj.city = window.parent['city'] ? window.parent['city'] : '';
            utagObj.state = window.parent['region_code'] ? window.parent['region_code'] : '';
            utagObj.ip_address = window.parent['iPAddress'] ? window.parent['iPAddress'] : '';*/
            /*if(cvsUtility.isMobile()){
                utagObj.platform="tablet";
            }else{
                utagObj.platform="desktop";
            }*/
        }
        //console.log(utagObj);
        var utagType = (typeof utag == 'undefined') ? false : true;
        if(utagType){
            if(data=="OBJ"){
                utag.view(utagObj);
                //utag_data = utagObj;
            }else if(data=="LINK"){
                utag.link(utagObj);
            }
            else if(data=="VIEW"){
                utag.view(utagObj);
            }
                 
        } 
               
    };
 }
	

 	return new webTrendsService();
}]);



